import { StructuredText } from 'react-datocms';
import { RowFragment } from '@/utils/dato/generated';
import { Document } from 'datocms-structured-text-utils';
import { FlexCol, FlexRow, grid } from '@zopauk/react-components';
import { customNodeRules, renderBlock } from '@/components/structuredText';
import {
  FlexJustificationValues,
  FlexAlignmentValues,
} from '@zopauk/react-components/types/components/layout/FlexRow/FlexRow';

const Row = ({ horizontalAlignment, verticalAlignment, totalColumns, columns, gutter }: RowFragment) => (
  <FlexRow
    justify={horizontalAlignment as FlexJustificationValues}
    align={verticalAlignment as FlexAlignmentValues}
    cols={totalColumns || grid.cols}
    gutter={gutter || grid.gutter}
    className="row"
  >
    {columns.map((column) => {
      const columnProps = column.breakpoints.reduce<Record<string, number>>((acc, current) => {
        if (current.breakpoint && current.size) {
          acc[current.breakpoint] = current.size;
        }
        return acc;
      }, {});

      return (
        <FlexCol className="column" key={column.id} {...columnProps}>
          {column.content ? (
            <StructuredText
              data={{ value: column.content.value as Document, blocks: column.content.blocks }}
              customNodeRules={customNodeRules}
              renderBlock={renderBlock}
            />
          ) : null}
        </FlexCol>
      );
    })}
  </FlexRow>
);

export default Row;
